import { Button, Card, Input, Popconfirm, Switch, Tooltip } from "antd";
import QuestionDraggable from "../QuestionDraggable/QuestionDraggable";
import styles from "./Question.module.css";
import { DownOutlined, UpOutlined, BranchesOutlined } from "@ant-design/icons";
import { memo, useContext } from "react";
import { ConditionQuestionsContext } from "./ConditionQuestionsContext";
import { IconButton } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteIcon from "@mui/icons-material/Delete";

const Question = ({
  formContainer = true,
  id,
  type,
  label,
  index,
  noLabel,
  cardType,
  reOrder,
  children,
  onChange,
  required,
  disabled,
  onRemove,
  noDetail,
  className,
  field_type,
  noRequired,
  description,
  selectLimit,
  duplicateQuestion,
  question_number,
  duplicateSubQuestion,
  deleteDuplicateOptions,
}) => {
  const involvedIds = useContext(ConditionQuestionsContext);
  const hasCondition = involvedIds ? involvedIds.has(String(id)) : false;

  const actions = [
    !noDetail ? (
      <div>
        <div>
          <b>توضیحات</b>
        </div>
        <Input
          onBlur={(e) => {
            onChange("description", e.target.value);
          }}
          className={styles.Description}
          defaultValue={description}
          placeholder="توضیحات"
        />
      </div>
    ) : null,

    reOrder ? (
      <div className={styles.ReOrder}>
        {reOrder.up && (
          <Button
            icon={<UpOutlined />}
            onClick={() => {
              reOrder.up();
            }}
          />
        )}
        {reOrder.down && (
          <Button
            icon={<DownOutlined />}
            onClick={() => {
              reOrder.down();
            }}
          />
        )}
      </div>
    ) : null,
    onRemove ? (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-evenly",
          height: "3.2rem",
          marginTop: "0.5rem",
        }}
      >
        <h4 style={{ fontWeight: "bold", fontSize: "1rem" }}>{type}</h4>

        <Popconfirm onConfirm={onRemove} title="آیا از حذف سوال مطمئن هستید؟">
          <DeleteIcon color="error" />
        </Popconfirm>
        {field_type === "checkboxes" && (
          <Tooltip placement="top" title="محدودیت انتخاب">
            <Input
              value={selectLimit}
              type="number"
              onChange={(e) => {
                if (+e.target.value > -1) {
                  onChange("selectLimit", e.target.value);
                }
              }}
              style={{ width: "4rem" }}
            />
          </Tooltip>
        )}
        {(duplicateQuestion || duplicateSubQuestion) && (
          <IconButton
            onClick={() =>
              duplicateSubQuestion
                ? duplicateSubQuestion(id)
                : duplicateQuestion(id)
            }
            style={{ marginLeft: "0.5rem" }}
            aria-label="duplicate"
          >
            <ContentCopyIcon />
          </IconButton>
        )}
        {!["voice", "image"].includes(field_type) && (
          <div>
            <Switch
              onChange={(checked) => {
                onChange("required", checked);
              }}
              defaultChecked={required}
            />
            <span style={{ marginRight: "0.2rem" }}>اجباری</span>
          </div>
        )}
        {["voice", "image"].includes(field_type) && (
          <div>
            <Switch
              onChange={(checked) => {
                onChange("canDownload", checked);
              }}
              defaultChecked={required}
            />
            <span style={{ marginRight: "0.2rem" }}>قابل دانلود</span>
          </div>
        )}

        {field_type === "multidropdown" && (
          <div>
            <Switch
              onChange={(checked) => {
                onChange("deleteDuplicateOptions", checked);
              }}
              defaultChecked={deleteDuplicateOptions}
            />
            <span style={{ marginRight: "0.2rem" }}>حذف گزینه تکراری</span>
          </div>
        )}
      </div>
    ) : null,
  ];

  const content = (
    <Card
      // type={cardType}
      className={[
        disabled ? styles.disabled : null,
        styles.Question,
        className,
      ].join(" ")}
      actions={actions.filter((el) => el !== null)}
      title={
        formContainer && !["html"].includes(field_type) ? (
          <div
            style={{
              display: "flex",
              justifyContent: "start",
            }}
          >
            <Input
              onChange={(e) => {
                if (!e.target.value) {
                  onChange("question_number", e.target.value);
                }
                if (/^[0-9.]+$/.test(e.target.value)) {
                  onChange("question_number", e.target.value);
                }
              }}
              size="large"
              value={question_number}
              className={styles.manualNumber}
              placeholder="شناسه"
            />
            {hasCondition && (
              <Tooltip title="این سوال در یک شرط استفاده شده است">
                <BranchesOutlined
                  style={{
                    color: "#1677ff",
                    fontSize: 18,
                    alignSelf: "center",
                    margin: "0 0.4rem",
                  }}
                />
              </Tooltip>
            )}
            <Input
              onBlur={(e) => {
                onChange("label", e.target.value);
              }}
              size="large"
              defaultValue={label}
              className={styles.Title}
              placeholder="عنوان سوال"
            />
          </div>
        ) : (
          type
        )
      }
      // title={type}
    >
      {/* {!noLabel && (
        <div style={{ display: "flex", alignItems: "center" }}>
          {noDetail && (
            <p style={{ fontWeight: 700, marginLeft: "1rem" }}>{index + 1}</p>
          )}
          <Input
            onBlur={(e) => {
              onChange("label", e.target.value);
            }}
            size="large"
            defaultValue={label}
            className={styles.Title}
            placeholder="عنوان سوال"
          />
          {noDetail && (
            <IconButton
              style={{ marginRight: ".5rem" }}
              onClick={() => {
                duplicateSubQuestion(id);
              }}
            >
              <ContentCopyIcon />
            </IconButton>
          )}
        </div>
      )} */}
      <div className={styles.Actions}></div>
      {children}
    </Card>
  );
  if (noDetail) {
    return content;
  }
  return (
    <QuestionDraggable index={index} id={id}>
      {content}
    </QuestionDraggable>
  );
};
export default memo(Question);
//
